var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _vm._l(4, function (x) {
        return _c(
          "div",
          { key: "device-details-review-skeleton" + x, staticClass: "mb-3" },
          [
            _c("device-details-review-skeleton"),
            _vm._v(" "),
            x < 4
              ? _c("hr", { staticClass: "separator separator--gray4 my-2" })
              : _vm._e(),
          ],
          1
        )
      }),
      _vm._v(" "),
      _vm._m(1),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "d-flex flex-row justify-content-between" },
      [
        _c("div", { staticClass: "ob1-skeleton my-2" }, [
          _c("div", {
            staticClass: "ob1-skeleton-white",
            staticStyle: { width: "150px", height: "20px" },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "ob1-skeleton my-2 d-md-none" }, [
          _c("div", {
            staticClass: "ob1-skeleton-white",
            staticStyle: { width: "70px", height: "20px" },
          }),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "d-flex flex-row justify-content-center mb-2" },
      [
        _c("div", { staticClass: "ob1-skeleton pr-5" }, [
          _c("div", {
            staticClass: "ob1-skeleton-white",
            staticStyle: { width: "120px", height: "70px" },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "ob1-skeleton pl-5" }, [
          _c("div", {
            staticClass: "ob1-skeleton-white",
            staticStyle: { width: "120px", height: "70px" },
          }),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }